<template>
  <ViewCustomData entityName="event_type_ext" entitySpec="data" serviceName="BaseService"
    :columns="PROPERTY_EVENT_COLUMNS" scrollHeight="250px" :paginator="false" mode="edit" :masterDetail="masterDetail"
    :requiredFieldsTable="{
      event_category_ext_name: true,
      event_type_ext_name: true,
      event_group_id: true,
      condition_code: true,
      property_value: true,
    }" :dictionary="PROPERTY_EVENT_DICTIONARY" :prepareInsert="prepareInsert" :prepareUpdate="prepareUpdate" />
</template>

<script setup>
import { computed, ref, defineProps } from 'vue';
import { PROPERTY_EVENT_DICTIONARY, PROPERTY_EVENT_COLUMNS } from './propertyConstants';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  source: { type: String, required: true },
  nullable: { type: String, required: true },
});

const selected = ref(null);

const masterDetail = computed(() => {
  if (props.data?.[props.source] && props.data?.[props.source] > -1) {
    return { [props.source]: props.data?.[props.source] };
  }
  return { [props.source]: -1 };
});

const prepareInsert = (rowData) => {
  const row = {
    event_type_ext_id: null,
    event_category_ext_name: rowData.event_category_ext_name,
    property_value: rowData.property_value,
    event_type_ext_name: rowData.event_type_ext_name,
    property_id: null,
    [props.source]: masterDetail.value[props.source],
    event_group_id: rowData.event_group_id,
    condition_code: rowData.condition_code,
    sound_enabled: rowData.sound_enabled,
  };
  row[props.nullable] = null;
  return row;
};

const beforeOpenNewRow = (rowData) => {
  rowData.condition_code = 0;
  rowData.property_value = 1;
  rowData.event_group_id = 1;
};

const prepareUpdate = (rowData) => {
  const row = {
    event_type_ext_id: rowData.event_type_ext_id,
    event_category_ext_name: rowData.event_category_ext_name,
    property_value: rowData.property_value,
    event_type_ext_name: rowData.event_type_ext_name,
    property_id: rowData.property_id,
    property_type_id: rowData.property_type_id,
    event_group_id: rowData.event_group_id,
    condition_code: rowData.condition_code,
    sound_enabled: rowData.sound_enabled,
  };
  return row;
};

</script>